"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var get_date_time_parts_1 = require("./get-date-time-parts");
var is_same_year_1 = require("./is-same-year");
function isSameMonth(date1, date2, timeZone) {
    var month1 = get_date_time_parts_1.getDateTimeParts(date1, timeZone).month;
    var month2 = get_date_time_parts_1.getDateTimeParts(date2, timeZone).month;
    return is_same_year_1.isSameYear(date1, date2, timeZone) && month1() === month2();
}
exports.isSameMonth = isSameMonth;
